<form class="search-form" *ngIf="teachers.length != 0">
    <mat-form-field class="teacher-search-field" floatLabel="always">
      <input type="text"
             placeholder="Click here to select teacher from list"
             aria-label="Teacher"
             matInput
             [formControl]="teacherSearchControl"
             [matAutocomplete]="auto"
             (focus)="$event.target.select()"
             #autoTeacher>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let teacher of filteredTeachers | async" [value]="teacher.FirstName" (click)="selectTeacher(teacher)">
          {{teacher.FirstName}} {{teacher.LastName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>